module.exports = __webpack_public_path__ + "spa-static/img/ok.c98219ac.svg";